import S3Uploader from './s3uploader.vue';
export default S3Uploader;
